interface SchemaProps {
  name: string;
  description: string;
}

export const Schema = ({ name, description }: SchemaProps) => {
  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    'name': name,
    'description': description,
    'publisher': {
      '@type': 'Organization',
      'name': 'ClearTax',
    },
    'license': '',
  };

  return `${JSON.stringify(schemaData, null, 4)}`;
};
